import React from "react";
import { AiOutlineMessage } from "react-icons/ai";
import { BsThreeDots, BsFillShareFill, BsHeart } from "react-icons/bs";
import profileImage from "../assets/profile.svg";
import moment from "moment";
import { formatNumber } from "../utils/dtos";
import VideoPlayer from "./Media/VideoPlayer";

const FeedProfile = ({ data }) => {
  const displayByType = (media) => {
    if (media.type === 'image') {
      return <div className='w-full'><img src={media?.url} alt="" className="w-full object-cover rounded-lg" /></div>
    } else {
      return <VideoPlayer controls={false} src={media?.url} />
    }
  }
  return (
    <div className="border-2 p-3 rounded-xl mt-5">
      <div className="flex justify-between items-center pb-3">
        <div className="flex items-start">
          <img className="h-12 w-12 rounded" src={data?.creator?.profilePicture || profileImage} alt="" />
          <div className="pl-5">
            <p className="text-xs font-medium">{data?.creator?.firstName} {data.creator?.lastName} .</p>
            <p className="text-[10px] font-medium">{data?.creator?.city} {data?.creator?.state}</p>
          </div>
          <p className="text-xs pl-5">{moment(JSON.stringify(data?.createdAt?.toDate()).replace(/['"]+/g, "")).fromNow()}</p>
        </div>
        <div className="text-2xl text-black text-opacity-50 cursor-pointer">
          <BsThreeDots />
        </div>
      </div>
      {data?.text && <p className="text-sm pb-3 max-h-20 text-ellipsis overflow-hidden">
        {data?.text}
      </p>}

      {(data?.media && data?.media.length > 0) && <div className="flex justify-center mt-3 items-center pb-3">
        {data?.media.length > 1 ? (
          <div className="flex items-center w-full">
            <div className="relative  w-[67%]">
              {displayByType(data?.media[0])}
            </div>
            <div className="pl-3 flex flex-col gap-3  w-[33%]">
              {data?.media?.length >= 2 && <div className=''>
                {displayByType(data?.media[1])}
              </div>}
              {data?.media?.length >= 3 && <div className="w-full relative">
                {displayByType(data?.media[2])}
                {data?.media?.length > 3 && <div className="absolute top-0 h-full gap-2 w-full flex justify-center bg-black bg-opacity-30 rounded-lg">
                  <div className="flex justify-center items-center">
                    <span className="text-4xl text-white">+{data?.media?.length - 3}</span>
                  </div>
                </div>}
              </div>}
            </div>
          </div>
        ) : (
          <div className="relative w-full">
            {data?.media[0].type === 'image' && <img
              src={data?.media[0].url}
              alt=""
              className="w-full h-full rounded-lg object-cover"
            />}

            {data?.media[0].type === 'video' &&  <VideoPlayer src={data?.media[0].url} />}

          </div>
        )}
      </div>}
      <div className="flex items-center">
        <div className="flex items-center pr-5">
          <AiOutlineMessage className="text-2xl cursor-pointer" />
          <p className="text-sm pl-5">{formatNumber(data?.likes.length)}</p>
        </div>
        <div className="flex items-center pr-5">
          <BsHeart className="text-2xl cursor-pointer" />
          <p className="text-sm pl-5">{formatNumber(data?.comments.length)}</p>
        </div>
        <div className="flex items-center pr-5">
          <BsFillShareFill className="text-2xl cursor-pointer" />
          {/* <p className="text-sm pl-5">500</p> */}
        </div>
      </div>
    </div>
  );
};

export default FeedProfile;
